import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import Modal from 'react-modal';
import { lazyInject } from '@intelingu/core/IoC/container';
import { CardStore } from '@intelingu/core/stores/CardStore';

export interface SkipTopicModalProps {
}

@observer export class SkipTopicModal extends Component<SkipTopicModalProps, any> {

    @lazyInject(CardStore) cardStore: CardStore;

    render() {
        return <Modal isOpen={this.cardStore.isSkipTopicAlert}
                      overlayClassName={'modal-overlay'}
                      shouldCloseOnOverlayClick={true}
                      onRequestClose={() => this.cardStore.isSkipTopicAlert = false}
                      className={'modal-content'}>
            <h1>Achtung</h1>
            <p>Das Überspringen dieser Karte führt zum Ausschluss aller Inhalte zum Thema "{ this.cardStore.currentCard.topic ? this.cardStore.currentCard.topic.title : '' }". Du wirst ab sofort auch keine Übungen mehr zu diesem Thema erhalten.</p>

            <h2>Fortfahren?</h2>

            <div className={'buttons-group'}>
                <button onClick={() => {
                    this.cardStore.isSkipTopicAlert = false;
                    this.cardStore.skip({ skipTopic: true });
                }}>Ja</button>
                <button onClick={() => this.cardStore.isSkipTopicAlert = false}>Nein</button>
            </div>
        </Modal>
    }

}
